import { makeOffer as _makeOffer } from 'src/thirdweb/dotc'
import useDotcContract from '../useDotcContract'
import { MakeDynamicOfferParams, MakeStaticOfferParams } from './types'
import {
  buildMakeDynamicOfferParams,
  buildMakeStaticOfferParams,
} from './utils'

const useMakeOffer = () => {
  const dotcContract = useDotcContract()

  const makeStaticOffer = (params: MakeStaticOfferParams) => {
    if (!dotcContract) return

    const makeOfferTx = _makeOffer({
      contract: dotcContract,
      ...buildMakeStaticOfferParams(params),
    })

    return makeOfferTx
  }

  const makeDynamicOffer = (params: MakeDynamicOfferParams) => {
    if (!dotcContract) return

    const makeOfferTx = _makeOffer({
      contract: dotcContract,
      ...buildMakeDynamicOfferParams(params),
    })

    return makeOfferTx
  }

  return {
    makeStaticOffer,
    makeDynamicOffer,
  }
}

export default useMakeOffer
